import { pick } from '@yp/common/identity.ts';
import { loadable } from '@yp/util.svelte/loadable.ts';

export const Orientation = loadable<
  Pick<DeviceOrientationEvent, 'alpha' | 'beta' | 'gamma' | 'absolute'>
>((set) => {
  const el = (e: DeviceOrientationEvent) => {
    const orientation = pick(e, 'alpha', 'beta', 'gamma', 'absolute');
    set(orientation);
  };
  try {
    window.addEventListener('deviceorientation', el);
  } catch (err) {
    console.warn('deviceorientation', err);
    // if (String(err).toLocaleLowerCase().includes('permission')) {
    //   console.log('deviceorientation', 'requires permission');
    // } else {
    //   console.warn('deviceorientation', err);
    // }
    return;
  }
  return () => {
    window.removeEventListener('deviceorientation', el);
  };
});

export function screenSize() {
  // iOS resolutions: https://www.ios-resolution.com/
  return [window.screen.width, window.screen.height];
}

export function isProbablyMobile() {
  // TODO: Consider these.
  // https://medium.com/geekculture/detecting-mobile-vs-desktop-browsers-in-javascript-ad46e8d23ce5
  let screen = screenSize();
  if (screen[0] > screen[1]) {
    screen = [screen[1], screen[0]];
  }
  return screen[0] < 450 && screen[0] * 1.5 <= screen[1];
}
